import React, { type HTMLAttributes } from 'react';
import styled from 'styled-components';
import type { OpeningHourTexts } from 'autogen/swagger/all';
import { Body } from 'components/generic/typography';
import { Spacing8 } from 'autogen/design-tokens/tokens';

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: max-content 1fr;
    column-gap: ${Spacing8};
`;

const StyledBody = styled(Body)`
    margin: 0;
`;

interface IOpeningHoursProps {
    openingHours: OpeningHourTexts[];
}

export default function OpeningHours(props: IOpeningHoursProps & HTMLAttributes<HTMLDivElement>): JSX.Element {
    const { openingHours, ...restProps } = props;

    return (
        <Wrapper {...restProps}>
            {openingHours.map((open) => (
                <React.Fragment key={open.days}>
                    <StyledBody size="M" strong={open.isCurrent}>
                        {open.days}:
                    </StyledBody>
                    <StyledBody size="M" strong={open.isCurrent}>
                        {open.openingHours}
                    </StyledBody>
                </React.Fragment>
            ))}
        </Wrapper>
    );
}
